export default __webpack_public_path__ + "static/media/Image file.a700ff33.svg";